const moment = require("moment");

function FormatCurrency(amount) {
    return (parseInt(amount) / 100).toFixed(2);
}

function WorkOutDepositPrice(amount, deposit) {
    return parseInt(parseInt(amount) / parseInt(deposit));
}

function WorkOutDepositRemainingAmount(amount, deposit) {
    const depositPrice = parseInt(parseInt(amount) / parseInt(deposit));
    return amount - depositPrice;
}

function WorkOutSale(totalOrder, sale) {
    return new Promise((resolve, reject) => {
        const startDate = moment(sale.startDate, "DD/MM/YYYY");
        const endDate = moment(sale.endDate, "DD/MM/YYYY");
        const today = moment();

        let dateValid = true;
        if (today.isBefore(startDate)) {
            dateValid = false;
        }
        if (today.isAfter(endDate)) {
            dateValid = false;
        }

        if (!dateValid) {
            const json = {
                error: "Yes",
                errorType: "date",
                startDate: sale.startDate,
                endDate: sale.endDate
            };
            resolve(json);
        } else {
            let saleValid = true;
            let total = 0;
            let description = "";
            let takenOffAmount = 0;

            if (sale.condition == "overcertainAmount") {
                const overAmount = parseFloat(sale.conditionValue) * 100;

                if (totalOrder < overAmount) {
                    saleValid = false;
                }
            }
            if (!saleValid) {
                const json = {
                    error: "Yes",
                    errorType: "overAmount",
                    overAmount: parseFloat(sale.conditionValue)
                };
                resolve(json);
            } else {
                if (sale.type == "money") {
                    takenOffAmount = sale.typeValue * 100;
                    total = totalOrder - takenOffAmount;
                    description = `£${sale.typeValue} off`;
                } else if (sale.type == "percentage") {
                    takenOffAmount = Math.round((totalOrder / 100) * parseInt(sale.typeValue));
                    total = totalOrder - takenOffAmount;
                    description = `${sale.typeValue}% off`;
                }

                const json = {
                    error: "null",
                    code: sale.code,
                    type: sale.condition,
                    message: "Coupon Accepted",
                    subTotal: total,
                    description: description,
                    takenOffAmount: takenOffAmount,
                    couponUUID: sale.uuid
                };
                // console.log(json);
                resolve(json);
            }
        }
    });
}

function WorkOutSaleWithoutDateConditions(totalOrder, sale) {
    return new Promise((resolve, reject) => {
        let saleValid = true;
        let total = 0;
        let description = "";
        let takenOffAmount = 0;

        if (sale.condition == "overcertainAmount") {
            const overAmount = parseFloat(sale.conditionValue) * 100;

            if (totalOrder < overAmount) {
                saleValid = false;
            }
        }
        if (!saleValid) {
            const json = {
                error: "Yes",
                errorType: "overAmount",
                overAmount: parseFloat(sale.conditionValue)
            };
            resolve(json);
        } else {
            if (sale.type == "money") {
                takenOffAmount = sale.typeValue * 100;
                total = totalOrder - takenOffAmount;
                description = `£${sale.typeValue} off`;
            } else if (sale.type == "percentage") {
                takenOffAmount = Math.round((totalOrder / 100) * parseInt(sale.typeValue));
                console.log(takenOffAmount);
                total = totalOrder - takenOffAmount;
                description = `${sale.typeValue}% off`;
            }

            const json = {
                error: "null",
                code: sale.code,
                type: sale.condition,
                message: "Coupon Accepted",
                subTotal: total,
                description: description,
                takenOffAmount: takenOffAmount,
                couponUUID: sale.uuid
            };
            // console.log(json);
            resolve(json);
        }
    });
}

module.exports = {
    FormatCurrency,
    WorkOutDepositPrice,
    WorkOutDepositRemainingAmount,
    WorkOutSale,
    WorkOutSaleWithoutDateConditions
};
